/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetChatHistory200ResponseInnerPartsInner
 */
export interface GetChatHistory200ResponseInnerPartsInner {
    /**
     * 
     * @type {string}
     * @memberof GetChatHistory200ResponseInnerPartsInner
     */
    type?: GetChatHistory200ResponseInnerPartsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetChatHistory200ResponseInnerPartsInner
     */
    text?: string;
}


/**
 * @export
 */
export const GetChatHistory200ResponseInnerPartsInnerTypeEnum = {
    Text: 'text'
} as const;
export type GetChatHistory200ResponseInnerPartsInnerTypeEnum = typeof GetChatHistory200ResponseInnerPartsInnerTypeEnum[keyof typeof GetChatHistory200ResponseInnerPartsInnerTypeEnum];


/**
 * Check if a given object implements the GetChatHistory200ResponseInnerPartsInner interface.
 */
export function instanceOfGetChatHistory200ResponseInnerPartsInner(value: object): value is GetChatHistory200ResponseInnerPartsInner {
    return true;
}

export function GetChatHistory200ResponseInnerPartsInnerFromJSON(json: any): GetChatHistory200ResponseInnerPartsInner {
    return GetChatHistory200ResponseInnerPartsInnerFromJSONTyped(json, false);
}

export function GetChatHistory200ResponseInnerPartsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChatHistory200ResponseInnerPartsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

  export function GetChatHistory200ResponseInnerPartsInnerToJSON(json: any): GetChatHistory200ResponseInnerPartsInner {
      return GetChatHistory200ResponseInnerPartsInnerToJSONTyped(json, false);
  }

  export function GetChatHistory200ResponseInnerPartsInnerToJSONTyped(value?: GetChatHistory200ResponseInnerPartsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'text': value['text'],
    };
}

